<template>
    <page :busy="busy" :tabs="tabs" :right-button="rightButton" class="pb-2">
        <router-view @busy="handleBusy"></router-view>
    </page>
</template>

<script>
import { mapGetters } from 'vuex';
import Page from '../generic/page/page.vue';

export default {
    name: 'Guest',
    components: { Page },
    mounted() {
        if (this.$route.path === '/app/guest/') {
            this.$router.push('/app/guest/list/');
        }
    },
    computed: {
        ...mapGetters('guest', ['metadata', 'detailsTabTitle']),
        guestId() {
            return parseInt(this.$route.params.id);
        },
        reservationView() {
            return this.metadata?.permissions?.reservation_view;
        },
        tabs() {
            const tabs = [];
            tabs.push({
                title: 'Guest List',
                route: `/app/guest/list/`,
                active: this.$route.path === `/app/guest/list/`,
            });
            if (this.guestId) {
                tabs.push({
                    title: this.detailsTabTitle.title,
                    titleIcon: this.detailsTabTitle.icon,
                    route: `/app/guest/${this.guestId}/edit/`,
                    active: this.$route.path === `/app/guest/${this.guestId}/edit/`,
                });
            }
            if (this.$route.path === `/app/guest/new/`) {
                tabs.push({
                    title: 'New Guest',
                    route: `/app/guest/new/`,
                    active: this.$route.path === `/app/guest/new/`,
                });
            }
            if (this.guestId && this.reservationView) {
                tabs.push({
                    title: 'Invoices',
                    route: `/app/guest/${this.guestId}/invoices/`,
                    active: this.$route.path === `/app/guest/${this.guestId}/invoices/`,
                });
            }
            return tabs;
        },
    },
    data() {
        return {
            busy: false,
            rightButton: {
                variant: 'outline-primary',
                rotation: '90',
                text: 'Add Reservation',
                callback: this.goToAddReservation,
                visible: this.addReservationIsVisible,
            },
        };
    },
    methods: {
        handleBusy(busy) {
            this.busy = busy;
        },
        goToAddReservation() {
            window.open(`/app/reservation/create?user=${this.guestId}`, '_blank');
        },
        addReservationIsVisible() {
            return this.$route.path !== `/app/guest/list/`;
        },
    },
};
</script>
